<script setup lang="ts">
import type { IDiscussionItem } from '~/components/entity/discussion/item/types'
import { LucideMessageCircleQuestion, LucideTag, LucideClock } from 'lucide-vue-next'

const props = defineProps<{ item: IDiscussionItem }>()

const { getPathWithLocale } = useLocalizedPath()

const truncated = computed(() => {
  if (!props.item.description) return ''
  return props.item.description.length > 200
    ? props.item.description.slice(0, 200) + '…'
    : props.item.description
})

const formattedDate = computed(() => {
  if (!props.item.updated_at) return ''
  return parseSiteDate(props.item.updated_at).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: SITE_TIME_ZONE
  })
})
</script>

<template>
  <article class="Card space-y-3">
    <div class="flex items-start gap-3">
      <div class="rounded-md bg-gray-100 p-2 mt-0.5 shrink-0">
        <LucideMessageCircleQuestion class="h-5 w-5 text-gray-900" />
      </div>
      <div class="flex-1 min-w-0">
        <Heading tag="h3" class="h5 !leading-5">
          <NuxtLinkLocale :to="props.item.url" class="hit-title hover:text-blue-600 transition-colors" v-html="props.item.title" />
        </Heading>
        <p v-if="truncated" class="mt-1 text-sm text-gray-600 line-clamp-2">{{ truncated }}</p>
      </div>
    </div>

    <div v-if="props.item.categories?.length || formattedDate" class="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500">
      <div v-if="props.item.categories?.length" class="flex flex-wrap gap-1">
        <NuxtLink
          v-for="cat in props.item.categories"
          :key="cat.id"
          :to="getPathWithLocale(cat.url)"
          class="inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-0.5 hover:bg-blue-50 hover:text-blue-600 transition-colors"
        >
          <LucideTag class="h-3 w-3" />
          {{ cat.title }}
        </NuxtLink>
      </div>
      <div v-if="formattedDate" class="flex items-center gap-1 ml-auto">
        <LucideClock class="h-3 w-3" />
        {{ formattedDate }}
      </div>
    </div>
  </article>
</template>
